export const SAFE_TEXT_WRAP = 'min-w-0 whitespace-normal break-words [overflow-wrap:anywhere]';

export const SAFE_COMPACT_VALUE = `${SAFE_TEXT_WRAP} leading-snug`;

export const SAFE_BADGE_TEXT = 'max-w-full whitespace-normal break-words [overflow-wrap:anywhere]';

export const RESPONSIVE_METRIC_CONTENT = 'min-w-0 flex-1';

export const RESPONSIVE_TABLE_TEXT = 'min-w-[10rem] whitespace-normal break-words [overflow-wrap:anywhere]';

export const RESPONSIVE_HEADER_ROW =
  'flex flex-col xl:flex-row xl:items-center xl:justify-between gap-4 min-w-0';

export const RESPONSIVE_ACTION_ROW =
  'flex flex-col xs:flex-row flex-wrap gap-2 xl:justify-end xl:shrink-0';

export const RESPONSIVE_BUTTON_TEXT = 'whitespace-normal h-auto min-h-10 leading-snug';
